<template>
  <!-- Seitenrahmen mit Kopf und Werkzeugleiste liegt in der Komponente (Kundenwunsch 13.10.2026: Aufbau wie die
       übrigen Seiten der Verwaltung) -->
  <driver-settlement-component />
</template>

<script>
import DriverSettlementComponent from "@/components/DriverSettlementComponent";

export default {
  components: {
    DriverSettlementComponent,
  },
};
</script>
